import { useTranslation } from 'react-i18next';

import { ListingCard } from './listing-card';
import { localePath } from '../lib/format';
import { guideImageAlt, guidePath } from '../lib/guides';
import { formatDateMedium } from '@todo/core/i18n/format';
import { useLocale } from '@todo/core/i18n/use-locale';
import { urlForImage } from '@todo/core/sanity/client';
import type { Article } from '@todo/core/sanity/queries';

/** A guide as a card: its cover, main topic, title and date. */
export function GuideCard({ article }: { article: Article }) {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const image = article.mainImage;
  const topic = article.topics?.[0];

  return (
    <ListingCard
      href={localePath(locale, guidePath(article.slug))}
      imageUrl={image ? urlForImage(image).width(480).height(320).url() : null}
      imageDesktopUrl={image ? urlForImage(image).width(720).height(480).url() : null}
      imageAlt={guideImageAlt(article)}
      category={topic ? t(`guides.topics.${topic}`, { defaultValue: t('guides.badge') }) : t('guides.badge')}
      title={article.title}
      facts={article.publishedAt ? [formatDateMedium(article.publishedAt, locale)] : undefined}
    />
  );
}
